import { render, staticRenderFns } from "./RemoveProbe.vue?vue&type=template&id=6bfdb7f8&scoped=true&"
import script from "./RemoveProbe.vue?vue&type=script&lang=js&"
export * from "./RemoveProbe.vue?vue&type=script&lang=js&"
import style0 from "./RemoveProbe.vue?vue&type=style&index=0&id=6bfdb7f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfdb7f8",
  null
  
)

export default component.exports